import { useSelector } from "react-redux";
import { TLegacyUser } from "../../api/types/User";
import svgIcons from "../../assets/svg/svgIcons";
import { LegacyVerifyEmailOtpResponseSuccess } from "../../api/types/Onboarding";
import { useLoginHandler } from "../../hooks/loginHandler";
import { routeUrls } from "../../navigation/routeUrls";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  localStorageKeys,
  useLocalStorage,
} from "../../utils/localStorageItems";

const SysadminAccountUserAccessBar = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "sysadmin.accountAccess",
  });
  const navigate = useNavigate();
  const { getLocalStorageItem } = useLocalStorage();

  const loggedInUserData = useSelector(
    (state: { commonReducer: { user: LegacyVerifyEmailOtpResponseSuccess } }) =>
      state.commonReducer.user
  );
  const loggedInUser: TLegacyUser =
    loggedInUserData?.user ?? getLocalStorageItem(localStorageKeys.user);
  const loginHandler = useLoginHandler({ screen: "loginScreen" });

  // handle switch account user to sysadmin
  const handleExitAccessSwitchToSysadmin = () => {
    const saData = getLocalStorageItem(
      `sa_${localStorageKeys.loggedInUserData}`
    );
    loginHandler.prepareSwitchAccountUserToSysadmin();
    // same-account login-as returns to the user list of that account
    if (saData?.user?.accountid === loggedInUser.accountid) {
      navigate(routeUrls.dashboardChildren.adminChildren.users);
    } else {
      navigate(
        (saData?.user?.account?.is_parent_account
          ? routeUrls.dashboardChildren.managedAccountUsers
          : routeUrls.sysadminChildren.account_users
        ).replace(":accountId", `${loggedInUser.accountid}`)
      );
    }
    window.location.reload();
  };

  return (
    <div className="fixed no-print top-0 w-full h-10 z-impersonation-bar bg-accent-blue-dark text-white flex justify-between">
      {/* Logged-in User Information */}
      <div className="flex items-center leading-4 md:leading-10 h-10 ps-4 text-xs md:text-base">
        <span>
          {t("logged_in_as")} <strong>{loggedInUserData?.user?.userid}</strong>{" "}
          (
          {`${t("account", {
            account_name: loggedInUserData?.user?.account.description,
          })} `}
          <span className="font-bold">{loggedInUserData?.user?.accountid}</span>
          )
        </span>
      </div>
      {/* Exit View Button */}
      <button
        className="group h-10 px-4 flex items-center text-md text-white hover:bg-white/20"
        onClick={handleExitAccessSwitchToSysadmin}
      >
        <img
          src={svgIcons.CloseIcon}
          className="size-6 md:mr-2 brightness-0 invert"
        />
        <span className="hidden md:block">{t("exit_access")}</span>
      </button>
    </div>
  );
};
export default SysadminAccountUserAccessBar;
